function sortingFunctionAscendingByName(a, b) {
    if (a.name !== undefined && b.name !== undefined && a.name < b.name)
        return -1;
    return 1;
}
export class TrainingManager {
    sendSaveBetweenResultsRequest;
    tasks = [];
    level;
    maxTp;
    bestScore;
    bonus = {
        benefits: 0,
        alchemy: 0,
        equipment: 0
    };
    retry = 0;
    tpPerTask;
    taskCount;
    constructor(sendSaveBetweenResultsRequest) {
        this.sendSaveBetweenResultsRequest = sendSaveBetweenResultsRequest;
    }
    setNumberOfTasks(value) {
        this.taskCount = value;
        this.tpPerTask = this.maxTp / value;
    }
    getTpPerTask() {
        return this.tpPerTask;
    }
    setUpFromData(data) {
        this.level = Number(data.task_level);
        this.maxTp = Number(data.tp_max);
        this.bestScore = Number(data.best_score);
        this.bonus = {
            benefits: Number(data?.bonus?.benefits ?? 0),
            alchemy: Number(data?.bonus?.alchemy ?? 0),
            equipment: Number(data?.bonus?.equipment ?? 0)
        };
    }
    getTrainingTasks() {
        const tasks = [...this.tasks];
        if (tasks.length < this.taskCount) {
            for (let i = this.tasks.length; i < this.taskCount; i++) {
                tasks.push({
                    name: '',
                    value: 0
                });
            }
        }
        return tasks.sort(sortingFunctionAscendingByName);
    }
    findTaskIndex(name) {
        return this.tasks.findIndex((item) => item.name === name);
    }
    getTask(name) {
        const existingEntryIndex = this.findTaskIndex(name);
        if (existingEntryIndex !== -1)
            return this.tasks[existingEntryIndex];
        return undefined;
    }
    setTaskValue(name, value) {
        const callback = () => { };
        const existingEntryIndex = this.findTaskIndex(name);
        const task = {
            name,
            value
        };
        if (existingEntryIndex === -1) {
            this.tasks.push(task);
            console.log(JSON.stringify(task));
            this.sendSaveBetweenResultsRequest(JSON.stringify(task), callback);
            return;
        }
        this.tasks[existingEntryIndex] = task;
        const stringData = JSON.stringify(this.tasks[existingEntryIndex]);
        this.sendSaveBetweenResultsRequest(stringData, callback);
    }
    getNewPotentialHighScore() {
        const newScore = this.tasks.reduce((acc, val) => (acc += Math.ceil(Math.round((val.value * this.tpPerTask * 10) + Number.EPSILON) / 10)), 0);
        const bonuses = (this.bonus.benefits + this.bonus.alchemy + this.bonus.equipment) / 100;
        const newScoreWBonuses = newScore + (bonuses * newScore);
        return Math.ceil(Math.round((newScoreWBonuses * 10) + Number.EPSILON) / 10);
    }
    isNewHighScore() {
        return this.getNewPotentialHighScore() > this.bestScore;
    }
    resetAll() {
        this.tasks = [];
        this.retry++;
    }
}
//# sourceMappingURL=TrainingManager.js.map